<template>
  <div class="wrapper">
    <div class="container">
      <div class="md-layout">
        <div
          class="md-layout-item md-size-66 md-xsmall-size-100 mx-auto text-center"
        >
          <h2 class="title text-center">
            {{ $t("assurance.titre-programme") }}
          </h2>
          <h5 class="description">
            {{ $t("assurance.sous") }}
          </h5>
        </div>
      </div>
      <div class="features text-center">
        <div class="md-layout">
          <div class="md-layout-item md-medium-size-33 md-small-size-100">
            <div class="info">
              <div class="icon icon-info">
                <md-icon>local_hospital</md-icon>
              </div>
              <h4 class="info-title">
                {{ $t("assurance.programme1.titre") }}
              </h4>
              <p>
                {{ $t("assurance.programme1.description") }}
              </p>
            </div>
          </div>
          <div class="md-layout-item md-medium-size-33 md-small-size-100">
            <div class="info">
              <div class="icon icon-success">
                <md-icon>local_atm</md-icon>
              </div>
              <h4 class="info-title">
                {{ $t("assurance.programme2.titre") }}
              </h4>
              <p>
                {{ $t("assurance.programme2.description") }}
              </p>
            </div>
          </div>
          <div class="md-layout-item md-medium-size-33 md-small-size-100">
            <div class="info">
              <div class="icon icon-warning">
                <md-icon>reply_all</md-icon>
              </div>
              <h4 class="info-title">
                {{ $t("assurance.programme3.titre") }}
              </h4>
              <p>
                {{ $t("assurance.programme3.description") }}
              </p>
            </div>
          </div>
          <div class="md-layout-item md-medium-size-33 md-small-size-100">
            <div class="info">
              <div class="icon icon-danger">
                <md-icon>airplanemode_inactive</md-icon>
              </div>
              <h4 class="info-title">
                {{ $t("assurance.programme4.titre") }}
              </h4>
              <p>
                {{ $t("assurance.programme4.description") }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <h2 class="title text-center">
      <md-button @click="goto" class="md-success md-lg text-center">
        {{ $t("assurance.souscrire") }}
      </md-button>
    </h2>
  </div>
</template>

<script>
export default {
  bodyClass: "landing-page",

  methods: {
    goto() {
      this.$router.push({ path: "/procedure", query: { type: "assurance" } });
    }
  }
};
</script>

<style lang="scss" scoped>
.md-card-actions.text-center {
  display: flex;
  justify-content: center !important;
}
.contact-form {
  margin-top: 30px;
}

.md-has-textarea + .md-layout {
  margin-top: 15px;
}
.hooper {
  height: auto;
}
</style>
